<template>
	<div id="footer">
		<p class="copyright">Copyright © 2017 易路交响 All rights reserved.&nbsp;&nbsp;&nbsp;</p>
		<p style="color:#6f6e6e;text-align:center">{{frontVersion}}--{{adminVersion}}</p>
	</div>
</template>

<script>
import request from "../../utils/request";
import { VERSION } from "../../pages/flow/config.js";
export default {
  name: "appFooter",
  data() {
    return {
      adminVersion: "", //后台版本
      frontVersion: "2.12.1" //前台版本
    };
  },
  created() {
    this.getVersion();
  },
  methods: {
    async getVersion() {
      const res = await request({
        data: {
          header: {
            serviceCode: "ABOUT",
            method: "version"
          },
          body: {}
        }
      });
      if (res.data.header.returnCode == "000000") {
        this.adminVersion = res.data.body.data;
      }
    }
  }
};
</script>

<style scoped lang="less">
#footer {
  position: relative;
  width: 100%;
  height: 70px;
  background: #2e2e2e;
  min-width: 1170px;
}

.copyright {
  line-height: 40px;
  text-align: center;
  color: #6f6e6e;
}
</style>


// WEBPACK FOOTER //
// foot.vue?6ee5e7ce